import { useState } from "react";
import { FIELDS } from "../datamodels.constants";
import { ServiceEditorModal } from "../../../components/organisms/ServiceEditors";
import NodeCollectionModal from "../../../components/organisms/AppModals/ServiceModals/NodeCollectionModal";

const { SQL_EXPRESSION, APPLICATION_JSON, HTML_MESSAGE, TEXT_MESSAGE, JS_CODE, APPLICATION_XML , PDF_MESSAGE} = FIELDS;
const expressionPrefix = "{{";
const expressionSuffix = "}}";
const modes = {
  [SQL_EXPRESSION]: "sql",
  [HTML_MESSAGE]: "html",
  [TEXT_MESSAGE]: "text",
  [APPLICATION_JSON]: "json",
  [APPLICATION_XML]: "text",
  [JS_CODE]: "javascript",
  [PDF_MESSAGE]: "html"
};

const ManageEditor = ({
  title,
  nodes,
  edges,
  values,
  shouldShow,
  setShouldShow,
  expressionKey,
  handleChange,
  helperText,
}) => {
  const [shouldShowExpression, setShouldShowExpression] = useState(false);

  return (
    <>
      <ServiceEditorModal
        nodes={nodes}
        title={title}
        mode={modes[expressionKey]}
        values={values}
        name={expressionKey}
        shouldShow={shouldShow}
        setShouldShow={setShouldShow}
        handleChange={handleChange}
        setShouldShowExpression={setShouldShowExpression}
        helperText={helperText}
      />
      {shouldShowExpression && (
        <NodeCollectionModal
          title={title}
          nodes={nodes}
          edges={edges}
          values={values}
          expressionKey={expressionKey}
          handleChange={handleChange}
          shouldShow={shouldShowExpression}
          expressionPrefix={expressionPrefix}
          expressionSuffix={expressionSuffix}
          setShouldShow={setShouldShowExpression}
        />
      )}
    </>
  );
};

export default ManageEditor;
